import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { styled } from 'styled-components';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var SearchFieldContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  @media (min-width: ", ") {\n    width: 16rem;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.md;
});
var SearchFieldInput = styled.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  font-size: 0.875rem;\n  border-radius: ", ";\n  outline: none;\n  background-color: ", ";\n  color: ", ";\n\n  &:focus {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n\n  &:focus-within {\n    background-color: ", ";\n  }\n\n  &::placeholder {\n    font-size: 0.875rem;\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.sizing.xlarge;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.sizing.large;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.sizing.xxlarge;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius.primary;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colours.canvas.secondary.main;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colours.canvas.secondary.ink;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colours.canvas.tertiary.main;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.effects.dropShadow.regular;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colours.canvas.tertiary.main;
});
var IconContainer = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  width: ", ";\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.sizing.large;
});
var EndContainer = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n\n  &:has(button) {\n    right: ", ";\n  }\n  &:has(div) {\n    right: ", ";\n    display: flex;\n    align-items: center;\n  }\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.sizing.tiny;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.sizing.small;
});

export { EndContainer, IconContainer, SearchFieldContainer, SearchFieldInput };
//# sourceMappingURL=SearchField.styles.js.map
